export const defaultImg = require("@/assets/img/default/defaultImage.jpg");
/**
 * 汽车类型
 *      0: "碰撞",
        1: "水淹",
        2: "报废",
        3: "二手车",
        4: "盗抢",
 * @param {*} accidentType 
 * @returns 
 */
export const displayAccidentTypes = (accidentType) => {
    if (!accidentType) {
        return "/";
    }
    const typesMap = {
        0: "碰撞",
        1: "水淹",
        2: "报废",
        3: "二手车",
        4: "盗抢",
        5: "火烧",
    };

    const types = accidentType
        .split(",")
        .map((type) => typesMap[type] || "/")
        .join(", ");

    return types;
}

/**
 * 拍卖会类型  
 * 公开拍卖会为 1 普通 2 一口价   
 * 专用拍卖会为 3 期车 4 专场
 */
export const displayAuctionTypes = (auctionType) => {
    // 转换为字符串
    auctionType = auctionType + "";
    switch (auctionType) {
        case '1':
            return "普通";
        case '2':
            return "一口价";
        case '3':
            return "期车";
        case '4':
            return "专场";
        default:
            return "未知";
    }
}

/**
 * 基础判断
 * 1是 2否
 */
export const displayBaseTypes = (baseType) => {
    switch (baseType) {
        case 1:
            return "是";
        case 2:
            return "否";
        default:
            return "/";
    }
}

/**
 * 车辆状态
 * 待委托、待保全、待整备、待上拍、已上拍、待交款、待提车、待过户
 */
export const CARSTYPE = (type) => {
    // 1委托 2保全 3保全失败 4整备 5待上拍 6上拍 7 流拍 8已成交 9已过户 10待付款 11待提车 12待过户 13 已上架 14 已下架 15 待成交 16下拍
    switch (type) {
        case 1:
            return "待委托";
        case 2:
            return "待保全";
        case 3:
            return "保全失败";
        case 4:
            return "待整备";
        case 5:
            return "待上拍";
        case 6:
            return "上拍";
        case 7:
            return "流拍";
        case 8:
            return "已成交";
        case 9:
            return "已过户";
        case 10:
            return "待交款";
        case 11:
            return "待提车";
        case 12:
            return "待过户";
        case 13:
            return "已上架";
        case 14:
            return "已下架";
        case 15:
            return "待成交";
        case 16:
            return "下拍";
        default:
            return '/'
    }
}

/**
 * 拍卖状态 auctionStatus 0未开始 1进行中 2已结束 3流拍
 */
export function displayAuctionStatus(auctionStatus) {
    switch (auctionStatus) {
        case 0:
            return "未开始";
        case 1:
            return "进行中";
        case 2:
            return "已结束";
        case 3:
            return "流拍";
        default:
            return "/";
    }
}

/**
 * 给拍卖状态设置不同的tag
 */

export function setAuctionStatusTag(auctionStatus) {
    switch (auctionStatus) {
        case 0:
            return "warning";
        case 1:
            return "success";
        case 2:
            return "danger";
        case 3:
            return "info";
        default:
            return "";
    }
}

/**
 * 判断是什么拍卖会
 */
export function displayAuctionType(auctionType) {
    const list = [
        {
            label: 1,
            value: "",
        },
        {
            label: 2,
            value: "",
        },
        {
            label: 3,
            value: "offer",
        },
        {
            label: 4,
            value: "special",
        },
    ];
    return list.find((item) => item.label == auctionType)?.value;
}


/**
    * 状态 0交款审核中、1支付成功、支2付失败、3冻结、4退款审核中、5已退款、6退款失败。
    */
export function handleStatus(status) {
    switch (status) {
        case 0:
            return "交款审核中";
        case 1:
            return "支付成功";
        case 2:
            return "支付失败";
        case 3:
            return "冻结";
        case 4:
            return "退款审核中";
        case 5:
            return "已退款";
        case 6:
            return "退款失败";
        default:
            return "/";
    }
}

// 根据上面的状态设置tag

export function setStatusTag(status) {
    switch (status) {
        case 0:
        case 4:
            return "warning";
        case 1:
        case 5:
            return "success";
        case 2:
        case 6:
            return "danger";
        case 3:
            return "info";
        default:
    }
}

/**
 *  拍卖会类型  1普通  2一口价 3期车 4专场 
 */
export function handleAuctionType(auctionType) {
    switch (auctionType) {
        case 1:
            return "普通";
        case 2:
            return "一口价";
        case 3:
            return "期车";
        case 4:
            return "专场";
        default:
            return "/";
    }
}

/**
 *  状态 0未提交 1待审核 2审核中 3审核通过 4审核失败
 */
export function handleAuditStatus(status) {
    switch (status) {
        case 0:
            return "未提交";
        case 1:
            return "待审核";
        case 2:
            return "审核中";
        case 3:
            return "审核通过";
        case 4:
            return "审核失败";
        default:
            return "/";
    }
}

// 通过 handleAuditStatus 设置tag
export function setAuditStatusTag(status) {
    switch (status) {
        case 1:
        case 2:
            return "warning";
        case 3:
            return "success";
        case 4:
            return "danger";
        default:
            return "";
    }
}


/**
 * 通过竞拍状态 使用不同颜色的tag
 * 中标/未中标 待确定/已中标/赢回失败
 */
export function setAuctionStatusTagByAuctionStatus(auctionStatus) {
    switch (auctionStatus) {
        case '中标':
            return "success";
        case '未中标':
            return "danger";
        case '待确定':
            return "warning";
        case '已中标':
            return "success";
        case '赢回失败':
            return "danger";
        default:
            return "";
    }
}